import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../images/circle-info-regular-full.svg'
import styles from './styles.module.css'

export default function PeopleCheckbox ({
  localPeopleData,
  setLocalPeopleData
}) {
  // Determine checked state from people_key
  const isChecked = localPeopleData.people_key === '*'

  const handleToggle = () => {
    setLocalPeopleData(prev => ({
      ...prev,
      people_key: prev.people_key === '*' ? '' : '*'
    }))
  }

  return (
    <div>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.hasPeopleRecordTitle}>People Database</h1>
        <Tooltip
          title='Filter to only return properties that have a people record'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '.MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='People Database help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div className={styles.hasPeopleRecordCheckboxContainer}>
        <input
          id='hasPeopleRecord'
          className={styles.hasPeopleRecordCheckbox}
          type='checkbox'
          checked={isChecked}
          onChange={handleToggle}
        />
        <label
          className={styles.hasPeopleRecordLabel}
          htmlFor='hasPeopleRecord'
        >
          Has people record
        </label>
      </div>
    </div>
  )
}
